export default __webpack_public_path__ + "static/media/question-circle.4fc1ddd7.svg";